const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, unknown>> = {};

const convertArraysToObjects = (obj: Record<string, unknown>): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (Array.isArray(value)) {
      const arrayAsObj: Record<string, unknown> = {};
      value.forEach((item, index) => {
        if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
          arrayAsObj[String(index)] = convertArraysToObjects(item as Record<string, unknown>);
        } else if (Array.isArray(item)) {
          arrayAsObj[String(index)] = convertArraysToObjects({ _: item })._;
        } else {
          arrayAsObj[String(index)] = item;
        }
      });
      result[key] = arrayAsObj;
    } else if (typeof value === 'object' && value !== null) {
      result[key] = convertArraysToObjects(value as Record<string, unknown>);
    } else {
      result[key] = value;
    }
  });
  return result;
};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = {};
    }

    // Try default export first, then fall back to the named export matching the namespace
    const data = module.default ?? module[namespace];
    if (data) {
      (messages[lang] as Record<string, unknown>)[namespace] = convertArraysToObjects(data as Record<string, unknown>);
    }
  }
});

export default messages;
